enum StateAreasEnum {
  NOT_DISPARED = 'UNKNOWN',
  RESOLVED = 'RESOLVED',
  FIRED = 'FIRING'
}

export default StateAreasEnum;
